export default function PersonalAccountPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <i className="ri-user-line text-5xl text-primary-400 mb-6 block" />
        <h1 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-4">
          Личный кабинет
        </h1>
        <p className="text-base md:text-lg text-foreground-600 max-w-md mx-auto mb-8">
          Функционал личного кабинета находится в разработке.
          Скоро здесь появится возможность отслеживать заявки и управлять подпиской.
        </p>
        <a
          href="/"
          className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-colors"
        >
          <i className="ri-arrow-left-line" />
          Вернуться на главную
        </a>
      </div>
    </div>
  );
}